package org.zq.flvtomp4.queue

enum class TaskStatus {
    WAITING,
    ANALYZING,
    CONVERTING,
    COMPLETED,
    FAILED,
    CANCELLED,
}
